/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBudgetAlertNotification extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBudgetAlertNotification");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBudgetAlertNotification.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBudgetAlertNotification>): BackgroundJobPayloadForBudgetAlertNotification {
        let obj = Object.assign(new BackgroundJobPayloadForBudgetAlertNotification(), model);
        BackgroundJobPayloadForBudgetAlertNotification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBudgetAlertNotification>): BackgroundJobPayloadForBudgetAlertNotification {
        if (!model) return null;
        return BackgroundJobPayloadForBudgetAlertNotification.newInstance(<BackgroundJobPayloadForBudgetAlertNotification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBudgetAlertNotification) {
        if (!obj) return;

        models.BackgroundJobPayloadForBudgetAlertNotification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBudgetAlertNotification): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBudgetAlertNotification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    job_id: string;

    /**
     * status
     */
    status: models.BudgetAlertTriggerStatus;

    status_reason: string;

}
